<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.769.27c.308.36.308.945 0 1.306L4.506 7.73a.712.712 0 01-1.117 0L.231 4.037a1.037 1.037 0 010-1.305.712.712 0 011.117 0l2.6 3.04L8.651.27a.712.712 0 011.117 0z" fill="currentColor"/></svg>
</template>
 